import { ImageEnhancementZoomImagesInterface } from '@/types/image-enhancement/imageEnhancementTypes'

/*  
    This helper method returns a variants based on a string    
*/
const findVariant = (size: string, variants: any) => {
  return variants.find((variant: string) => variant.includes(size))
}

/*  
  This method returns the request variants
  It has a fallback mechanism that works like this
  If we request a size that is desbirbes in the sizes array but not present in the figure array
  It will check for the next best thing, it returns 4X for example when 6X is not available
  If the size is a string like 'public', it just returns the variant or not
  The method always defaults to public if nothing is found.     
*/
export const getCloudflareImage = (
  size: 1 | 2 | 4 | 6 | 'thumbnail' | 'public',
  figure: ImageEnhancementZoomImagesInterface
) => {
  if (!figure) return null

  // When no variants, return the URL
  // Media server fallback
  if (!figure.variants) {
    return figure.url
  }

  // Get the right variant
  let foundSize = ''
  if (typeof size === 'number') {
    const sizes = [6, 4, 2, 1]
    const sizeIndex = sizes.indexOf(size)
    if (sizeIndex !== -1) {
      sizes.slice(sizeIndex, sizes.length).every((size) => {
        foundSize = findVariant(size.toString() + 'X', figure.variants)
        return !foundSize
      })
    }
  } else {
    foundSize = findVariant(size, figure.variants)
  }

  // If found return, otherwise return public
  return foundSize || figure.variants.find((variant: string) => variant.includes('public'))
}
